<template>
  <div class="quote-block" v-if="!loading">
    <router-link :to="{ name: 'detail' }">
      <span class="quote-block__back">indietro</span>
    </router-link>
    <h1 class="quote-block__heading">Chi parteciperà al viaggio?</h1>
    <p>
      Inserisci con attenzione i dati dei viaggiatori così come indicati nel
      documento di identità che verrà usato per il viaggio. Tutti i campi sono
      obbligatori.
    </p>

    <package-summary
      :services="quote.services"
      :live_price="Number(quote.live_price)"
      :availability="availability"
    />

    <passengers-info :passengers="passengers_list">
      <template #footer="{ invalid, errors }">
        <disclaimer-checkout
          :invalid="invalid"
          :errors="errors"
          @checkout="goto_checkout"
        />
      </template>
    </passengers-info>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { custom_event, get_config } from "@utilities/commons";
import { build_passengers_model, get_departure_date } from "./logic/passenger";
import PackageSummary from "./package-summary.vue";
import PassengersInfo from "./passengers-info.vue";
import DisclaimerCheckout from "./disclaimer-checkout.vue";

export default {
  name: "quote-block",
  components: {
    "package-summary": PackageSummary,
    "passengers-info": PassengersInfo,
    "disclaimer-checkout": DisclaimerCheckout,
  },
  props: {
    quote: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState("liveat", ["selected_room", "checkin_date", "checkout_date"]),
    ...mapGetters("liveat", ["is_only_stay_package"]),
    passengers: {
      get() {
        return this.$store.state.liveat.passengers;
      },
      set(value) {
        this.$store.commit("liveat/passengers", value);
      },
    },
    passengers_list() {
      return (this.passengers && this.passengers.passengers) || [];
    },
    availability() {
      return this.get_availability();
    },
  },
  data() {
    return {
      loading: true,
    };
  },
  mounted() {
    this.init_passengers();
    this.loading = false;
  },
  methods: {
    init_passengers() {
      const departure_date = get_departure_date(this.quote);
      this.passengers = build_passengers_model({
        quote: this.quote,
        departure_date,
        checkin_date: this.checkin_date,
      });
    },

    goto_checkout() {
      const { quote_payload = {} } = this.selected_room || {}
      const { totAmount = 0 } = quote_payload
      custom_event(
        "initiateCheckout",
        get_config("integration.company"),
        totAmount,
        "partnerBehaviour",
      );

      this.track_form({
        event: "passengers-info:submit",
        data: { type: "info" },
      });

      this.$store.commit("liveat/quote", this.quote);
    },
  },
};
</script>

<style lang="scss" scoped>
.quote-block {
  margin-bottom: $grid-gutter-width * 4;

  &__back {
    color: $info;
    font-size: $font-size-sm;
  }

  &__heading {
    font-size: $h2-font-size;
    margin-top: $grid-gutter-width/2;
  }
}
</style>
